// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import styled from 'styled-components';

export const StyledHeader = styled.header`
  padding: 0.5rem 0;
  border-bottom: 1px solid ${(props) => props.theme.colors.greys.grey20};

  svg {
    vertical-align: bottom;
    width: 120px;
    height: 33px;
  }

  ${({ theme }) => theme.mediaQueries.min.md} {
    svg {
      width: 152px;
      height: 42px;
    }
  }
`;
